import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/video-cover.png'
import _imports_1 from '../assets/images/play-btn.png'
import _imports_2 from '../assets/images/rec_titile_left.png'
import _imports_3 from '../assets/images/rec_titile_right.png'
import _imports_4 from '../assets/images/info_ico.png'
import _imports_5 from '../assets/images/no-data.png'
import _imports_6 from '../assets/images/loading_new.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-23de00ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "talqs-app": "" }
const _hoisted_2 = { class: "question-result-container" }
const _hoisted_3 = {
  key: 0,
  class: "result-header"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "result-container" }
const _hoisted_6 = {
  key: 0,
  class: "result-con"
}
const _hoisted_7 = { class: "no-result" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "没有找到作答", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-result-con" }, [
  /*#__PURE__*/_createElementVNode("p", null, "可能原因："),
  /*#__PURE__*/_createElementVNode("p", null, "1. 题目未作答"),
  /*#__PURE__*/_createElementVNode("p", null, "2. 图片模糊/倾斜")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "gray-line"
}
const _hoisted_11 = { class: "result-container pb" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left-line" }, null, -1))
const _hoisted_14 = { class: "result-con talqs" }
const _hoisted_15 = {
  ref: "question_title",
  id: "question_title"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-line" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "left-line" }),
  /*#__PURE__*/_createTextVNode("图文解析")
], -1))
const _hoisted_18 = { class: "result-con talqs" }
const _hoisted_19 = {
  ref: "question_analysis",
  id: "question_analysis"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"0","overflow":"hidden"} }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-line" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "left-line" }),
  /*#__PURE__*/_createTextVNode("视频解析")
], -1))
const _hoisted_23 = { class: "result-con" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "result-img"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "video-btn"
}, null, -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 2,
  class: "scan-again"
}
const _hoisted_28 = {
  key: 0,
  class: "recommend-box"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray-line notop" }, null, -1))
const _hoisted_30 = { class: "rec-title" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "rec-title-ico"
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rec-title-txt" }, "智能推荐", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "rec-title-ico"
}, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "no-data-img"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data-txt" }, "页面出问题了，请点击重试", -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = {
  key: 2,
  class: "new-loading"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new-loading-con" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }),
  /*#__PURE__*/_createElementVNode("p", null, "解析加载中…")
], -1))
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_detail = _resolveComponent("question-detail")!
  const _component_close_recommend = _resolveComponent("close-recommend")!
  const _component_rocket = _resolveComponent("rocket")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loadingStatus === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.serviceVersion < 7 && _ctx.questions.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: "javascript:;",
                      class: _normalizeClass(["result-header-item", { cur: _ctx.currentQuestionIndex == index }]),
                      key: index,
                      onClick: ($event: any) => (_ctx.changeQuestion(index))
                    }, "题" + _toDisplayString(index + 1), 11, _hoisted_4))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              (JSON.stringify(_ctx.currentQuestion) != '{}' && _ctx.currentQuestion.user_has_answer === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _hoisted_9,
                      (_ctx.serviceVersion < 7)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "retake-btn page-bottom",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.retake()))
                          }, " 再拍一次 "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (JSON.stringify(_ctx.currentQuestion) != '{}' && _ctx.currentQuestion.user_has_answer != 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.serviceVersion < 7)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.questionResolves[_ctx.currentQuestionIndex].hasResolve > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_ctx.questionResolves[_ctx.currentQuestionIndex].hasResolve === 2)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("h4", null, [
                                  _hoisted_13,
                                  _createTextVNode("题目 "),
                                  (_ctx.serviceVersion > 8)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (
                        _ctx.questionResolves[_ctx.currentQuestionIndex].nryContent
                          .is_wrong_question == 0
                      )
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              href: "javascript:;",
                                              class: "join-wrong",
                                              onClick: _cache[1] || (_cache[1] = ($event: any) => (
                        _ctx.addWrongList(
                          _ctx.questionResolves[_ctx.currentQuestionIndex].nryContent.nry_question_id
                        )
                      ))
                                            }, "加入错题本"))
                                          : (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: "javascript:;",
                                              class: "cancel-wrong",
                                              onClick: _cache[2] || (_cache[2] = ($event: any) => (
                        _ctx.cancelWrongQuestion(
                          _ctx.questionResolves[_ctx.currentQuestionIndex].nryContent.nry_question_id
                        )
                      ))
                                            }, "移出错题本"))
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, null, 512)
                                ]),
                                _hoisted_16,
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, null, 512),
                                  _hoisted_20
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentQuestion.qr_code)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_21,
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", {
                              class: "video-box",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getVideoInfo()))
                            }, _hoisted_26)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.serviceVersion < 7)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createTextVNode(" 看完解析，"),
                          _createElementVNode("span", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.retake()))
                          }, "再拍一页")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.intelligent_recommendation === 1 && _ctx.questionResolves[_ctx.currentQuestionIndex].hasResolve === 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (
              _ctx.isIntellectRecommend == '2' ||
              (_ctx.isIntellectRecommend == '1' &&
                _ctx.recommendQuestions[_ctx.currentQuestionIndex] &&
                _ctx.recommendQuestions[_ctx.currentQuestionIndex].length > 0)
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _hoisted_32,
                          _hoisted_33,
                          _createElementVNode("img", {
                            src: _imports_4,
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showRecommendTips && _ctx.showRecommendTips(...args))),
                            class: "info-ico"
                          })
                        ]),
                        (_ctx.isIntellectRecommend == '1')
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.recommendQuestions[_ctx.currentQuestionIndex], (question, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "recommend-item",
                                key: index
                              }, [
                                _createVNode(_component_question_detail, {
                                  questionIndex: index + 1,
                                  questionData: question,
                                  source: "pho_check_page"
                                }, null, 8, ["questionIndex", "questionData"]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["gray-line notop", {
                    'big-bottom':
                      index === _ctx.recommendQuestions[_ctx.currentQuestionIndex].length - 1,
                  }])
                                }, null, 2)
                              ]))
                            }), 128))
                          : (_ctx.isIntellectRecommend == '2')
                            ? (_openBlock(), _createBlock(_component_close_recommend, {
                                key: 1,
                                source: "question"
                              }))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.loadingStatus === 2)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "no-question-data",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reload()))
            }, _hoisted_36))
          : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
        : _createCommentVNode("", true),
      (_ctx.isShowRocket)
        ? (_openBlock(), _createBlock(_component_rocket, {
            key: 3,
            onClick: _ctx.goTop
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}